















































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Route, NavigationGuardNext } from 'vue-router';

import * as firebase from "firebase/app";

import { Person } from "@/scripts/datatypes";
import { firestore } from "@/scripts/firebase";

import json from "../../../private/persons.json";

import AdminButtons from "@/components/AdminButtons.vue";
import Admin from "@/mixins/Admin.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({ components: { AdminButtons }, mixins: [Admin]})
export default class Persons extends Vue {
  persons: Array<Person> = [];
  columns = [
    {
      field: "organization",
      label: "Organization",
      width: "320",
      searchable: true,
      sortable: true,
    },
    {
      field: "officer",
      label: "Officer",
      searchable: true,
      sortable: true,
    },
    {
      field: "name",
      label: "Name",
      searchable: true,
      sortable: true,
    },
    {
      field: "date",
      label: "Date",
      centered: true,
      sortable: true,
    }
  ];
  checkedRows = [];
  openedDetailed = [];
  detacher?: firebase.Unsubscribe;

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    next(vm => {
      if (
        vm.$store.state.user.uid != "EhJwGIUSFzOdVMvpoNigKgdc91n1" &&
        vm.$store.state.user.uid != "tceYfMwHleZkP5ErLzgeB8rygeY2"
      ) {
        next({ path: "/" });
      }
    });
  }

  async created() {
    this.detacher = this.refPersons.onSnapshot(
      (snapshot: firebase.firestore.QuerySnapshot) => {
        this.persons = snapshot.docs.map(doc => {
          return Object.assign(doc.data(), { id: doc.id }) as Person;
        });
      }
    );
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  get refPersons(): firebase.firestore.Query {
    return firestore()
      .collection("persons")
      .orderBy("timeCreated");
  }

  get hasUser(): boolean {
    return !!this.$store.state.user;
  }

  get signatures(): string {
    const signatures = this.checkedRows
      .map((r: Person) => {
        const line = "________________________________________________________";
        return `\n\n${line}\n${r.name}, ${r.officer}\n`;
      })
      .join("");

    return signatures;
  }

  handleDelete() {
    // https://firebase.google.com/docs/firestore/manage-data/delete-data#node.js_2
    console.log("handleDelete() is called.");

    const persons = firestore().collection("persons");
    persons
      .get()
      .then(snapshot => {
        // When there are no documents left, we are done
        if (snapshot.size === 0) {
          return 0;
        }

        // Delete documents in a batch
        const batch = firestore().batch();
        snapshot.docs.forEach(doc => {
          batch.delete(doc.ref);
        });

        return batch.commit().then(() => {
          return snapshot.size;
        });
      })
      .then(numDeleted => {
        if (numDeleted === 0) {
          // resolve();
          return;
        }

        // Recurse on the next process tick, to avoid
        // exploding the stack.
        // process.nextTick(() => {
        //   // deleteQueryBatch(db, query, resolve, reject);
        //   handleDelete();
        // });
      })
      .catch();
    // .catch(reject);
  }

  handleRefresh() {
    console.log("handleRefresh() is called.");

    const persons = firestore().collection("persons");

    json.forEach(p => {
      persons.add({
        organization: p.organization,
        officer: p.officer,
        name: p.name,
        cell: p.cell ?? "",
        phone: p.phone ?? "",
        email: p.email ?? "",
        expiration: p.expiration ?? "",
        timeCreated: firestore.FieldValue.serverTimestamp()
      });
      console.log(p, " is added.");
    });

    // persons.add({ organization: "Ada County", officer: "Clerk", name: "test" });
  }

  toggle(row: Person) {
    (this.$refs.table as Vue & { toggleDetails: (row: Person) => void }).toggleDetails(row)
  }

  copy(element: string) {
    navigator.clipboard.writeText(element);
    this.$buefy.notification.open({
      duration: 1000,
      message: `"${element}" is copied into your clipboard!`,
      position: "is-bottom-right",
      type: "is-info",
      hasIcon: true
    });
  }

  copySignatures() {
    navigator.clipboard.writeText(this.signatures);
    const message =
      this.checkedRows.length == 1 ? "Signature is" : "Signatures are";
    this.$buefy.notification.open({
      duration: 3000,
      message: `${message} copied into your clipboard!`,
      position: "is-bottom-right",
      type: "is-info",
      hasIcon: true
    });
  }
}
